let sdkPromise = null;

// Loads the Square Web Payments SDK (sandbox or production) exactly once.
export function loadSquareSdk(environment) {
  if (typeof window !== "undefined" && window.Square) return Promise.resolve(window.Square);
  if (sdkPromise) return sdkPromise;
  const url =
    environment === "production"
      ? "https://web.squarecdn.com/v1/square.js"
      : "https://sandbox.web.squarecdn.com/v1/square.js";
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = url;
    s.async = true;
    s.onload = () => resolve(window.Square);
    s.onerror = () => reject(new Error("Failed to load Square SDK"));
    document.head.appendChild(s);
  });
  return sdkPromise;
}
